export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2 space-y-4">
            <div className="flex items-center space-x-3">
              <div>
                <h3 className="text-xl font-bold">Susana Asesora de Salud</h3>
                <p className="text-sm text-gray-400">Orientación personalizada en salud previsional</p>
              </div>
            </div>
            <p className="text-gray-400 leading-relaxed max-w-md">
              Brindo orientación comercial y acompañamiento personalizado para ayudarte a entender y gestionar mejor tu plan de salud en todo Chile.
            </p>
            <div className="pt-4">
              <p className="text-xs text-gray-500 leading-relaxed">
                <i className="ri-information-line mr-1"></i>
                Sitio web personal de orientación comercial. No corresponde al sitio oficial de Consalud. La contratación se realiza por canales autorizados.
              </p>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contacto</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="https://wa.me/56944540956"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-2 text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-lg"></i>
                  <span className="text-sm">+56 9 1234 5678</span>
                </a>
              </li>
              <li>
                <a
                  href="mailto:susana@asesora-salud.cl"
                  className="flex items-center space-x-2 text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  <i className="ri-mail-line text-lg"></i>
                  <span className="text-sm">susana@asesora-salud.cl</span>
                </a>
              </li>
              <li className="flex items-center space-x-2 text-gray-400">
                <i className="ri-map-pin-line text-lg"></i>
                <span className="text-sm">Todo Chile</span>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Horario</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>Lunes a Viernes</li>
              <li className="font-medium text-white">9:00 - 19:00</li>
              <li className="mt-3">Sábados</li>
              <li className="font-medium text-white">10:00 - 14:00</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-700">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              © {currentYear} Susana Asesora de Salud. Todos los derechos reservados.
            </p>
            <div className="flex items-center space-x-6">
              <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                Política de Privacidad
              </a>
              <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                Términos de Uso
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}